export const buildPurpose = process.env.VUE_APP_BUILD_PURPOSE;

export const fallbackLocale = 'en-US';

const apiUrlMap = {
  test: 'https://testapi.payarc.net/v1',
  stage: 'https://staging.payarc.net:9000/v1',
  release: 'https://api.payarc.net/v1',
  preprod: 'https://api.payarc.io/v1',
  preprod2: 'https://api2.payarc.io/v1',
  dev: 'http://localapi2.payarc.net/v1',
  // bluegreen: 'https://api.payarc.net:8443/v1',
  bluegreen: 'https://api2.payarc.net/v1',
  uat: 'https://uatapi.payarc.net/v1',
};
export const apiUrl = apiUrlMap[buildPurpose] || apiUrlMap.dev;

// 3DS Integrator (PAAY) v2 authentication endpoint, keyed by build purpose —
// mirrors the backend convention of resolving the 3DSi endpoint per environment
// (see paay-container.php) rather than hardcoding it. Dev/test/stage/preprod
// builds use the sandbox host; uat and release/bluegreen hit the live host
// because they need to validate the real 3DS integration.
const threeDsEndpointMap = {
  dev: 'https://api-sandbox.3dsintegrator.com/v2.2',
  test: 'https://api-sandbox.3dsintegrator.com/v2.2',
  stage: 'https://api-sandbox.3dsintegrator.com/v2.2',
  preprod: 'https://api-sandbox.3dsintegrator.com/v2.2',
  preprod2: 'https://api-sandbox.3dsintegrator.com/v2.2',
  release: 'https://api.3dsintegrator.com/v2.2',
  bluegreen: 'https://api.3dsintegrator.com/v2.2',
  uat: 'https://api.3dsintegrator.com/v2.2',
};
export const threeDsEndpoint = threeDsEndpointMap[buildPurpose] || threeDsEndpointMap.dev;

const formLoadingPageUrlMap = {
  test: 'https://test.payarc.net:9091?loading=true',
  stage: 'https://staging.payarc.net:9091?loading=true',
  release: 'https://release.payarc.net:9091?loading=true',
  preprod: 'https://release.payarc.io:9091?loading=true',
  preprod2: 'https://release2.payarc.io:9091?loading=true',
  dev: 'https://dev.payarc.io:9091?loading=true',
  bluegreen: 'https://release.payarc.net:9091?loading=true',
};
export const formLoadingPageUrl = formLoadingPageUrlMap[buildPurpose] || formLoadingPageUrlMap.dev;

export const paypalClientId = (process.env.VUE_APP_BUILD_PURPOSE === 'release' || process.env.VUE_APP_BUILD_PURPOSE === 'bluegreen') ? 'AQOiuJxBnckcmQgf-3KgQIdsv9tIUINwb5YBVL2fKhKXk5TUQMB-sDiE0FwyCEkUPGZKhkowU-BkoJsM'
  : 'AYCHGtqmA9fg4Y2nZMha_U5A-qc3ll7kAemZmOWr-Eh2P7x_K_UZ3eWw0oJn4aLlzI3NZ99-WjPJAqSP';

// Google reCAPTCHA v3 site key (PDT-26303). The site key is public — it ships in
// the client bundle by design — so it lives here like paypalClientId rather than
// being injected via a build env var. Same key across environments today; switch
// to a buildPurpose map (see apiUrlMap above) if per-env keys are needed later.
// The feature stays dormant until the backend global switch and per-merchant
// toggle are on. The secret key lives only on the backend, never here.
export const recaptchaSiteKey = '6LfsBE0tAAAAAN3fwbgNII4t4NKQr6SkQ351khTb';
